(function(){
    var productListXhr;

    sidebar_filters_update(true);

    document.body.addEventListener('click', function (event) {
        if (event.target.closest('.pls-filters-toggle')) {
            var element = event.target.closest('.pls-filters-toggle');
            var isSelected = element.classList.contains('selected');
            if (!isSelected) {
                element.classList.add('selected');
            } else {
                element.classList.remove('selected');
            }
            document.activeElement.blur();
            sidebar_filters_update();
            return false;
        }
    });

    document.body.addEventListener('click', function (event) {
        if (event.target.closest('.pls-filters-reset')) {
            document.querySelectorAll('.pls-filters-toggle.selected').forEach(function (btn) {
                btn.classList.remove('selected');
            });
            document.querySelectorAll('.product-list-sidebar input[name="q"]').forEach(function (input) {
                input.remove();
            });
            sidebar_filters_update();
            return false;
        }
    });

    document.body.addEventListener('click', function (event) {
        if (event.target.closest('.pls-filters-deselect')) {
            var element = event.target.closest('.pls-filters-deselect');
            var key = element.getAttribute('data-filters-key');
            var value = element.getAttribute('data-filters-value');
            document.querySelectorAll('.pls-filters-toggle.selected').forEach(function (btn) {
                var key2 = btn.getAttribute('data-filters-key');
                var value2 = btn.getAttribute('data-filters-value');
                if (key === key2 && value === value2) {
                    btn.classList.remove('selected');
                }
            });
            document.querySelectorAll('.product-list-sidebar input').forEach(function (input) {
                var key2 = input.getAttribute('name');
                if (key === key2) {
                    input.remove();
                }
            });
            sidebar_filters_update();
            return false;
        }
    });

    // Handle view type buttons - grid or list
    document.body.addEventListener('click', function (event) {
        if (event.target.closest('.pli-set-view')) {
            var element = event.target.closest('.pli-set-view');
            var productListMainContainer = element.closest('.product-list-container');
            var productListItemsContainer = productListMainContainer.querySelector('.product-list-items');

            var newViewType = element.getAttribute('data-view-type');

            productListItemsContainer.classList.remove('product-list-items-list');
            productListItemsContainer.classList.remove('product-list-items-grid');

            productListItemsContainer.classList.add('product-list-items-'+newViewType);

            productListMainContainer.querySelectorAll('.pli-set-view').forEach(function(btn){
                btn.classList.remove('active');
            });
            element.classList.add('active');

            return false;
        }
    });

    // Handle sorting buttons
    document.body.addEventListener('click', function (event) {
        if (event.target.closest('.pli-set-sorting')) {
            var element = event.target.closest('.pli-set-sorting');
            var productListMainContainer = element.closest('.product-list-container');
            var hiddenInput = productListMainContainer.querySelector('input[name="sorting"]');

            var newSortingValue = element.getAttribute('data-value');
            var currentSortingValue = hiddenInput.value;

            if (newSortingValue === currentSortingValue) {
                hiddenInput.value = '';
                element.classList.remove('active');
            } else {
                hiddenInput.value = newSortingValue;
                productListMainContainer.querySelectorAll('.pli-set-sorting').forEach(function(btn){
                    btn.classList.remove('active');
                });
                element.classList.add('active');
            }

            sidebar_filters_update();
            return false;
        }
    });

    // Handle sorting select
    document.body.addEventListener('click', function (event) {
        if (event.target.closest('.pls-sorting-select-cancel')) {
            var element = event.target.closest('.pls-sorting-select-cancel');
            var productListMainContainer = element.closest('.product-list-container');

            var select = productListMainContainer.querySelector('.pls-sorting-select');
            select.value = '';
            select.dispatchEvent(new Event('change', {bubbles: true}));
            select.focus();
        }
    });
    document.body.addEventListener('change', function (event) {
        if (event.target.closest('.pls-sorting-select')) {
            var element = event.target.closest('.pls-sorting-select');
            var productListMainContainer = element.closest('.product-list-container');
            var hiddenInput = productListMainContainer.querySelector('input[name="sorting"]');
            var overlayButton = productListMainContainer.querySelector('.product-list-sidebar-sorting-select .btn');

            var newSortingValue = element.value;
            var newSortingTitle = element.options[element.selectedIndex].text;

            overlayButton.querySelector('span').innerText = newSortingTitle;

            console.log(newSortingValue.length);

            if (!newSortingValue.length) {
                hiddenInput.value = '';
                overlayButton.classList.remove('active');
            } else {
                hiddenInput.value = newSortingValue;
                overlayButton.classList.add('active');
            }

            sidebar_filters_update();
            return false;
        }
    });

    // Load more items
    document.body.addEventListener('click', function (event) {
        if (event.target.closest('.pli-load-more')) {
            var element = event.target.closest('.pli-load-more');
            var url = element.getAttribute('data-url');

            var productListMainContainer = document.querySelector('.product-list-container');
            var productListItemsContainer = productListMainContainer.querySelector('.product-list-items');

            element.classList.add('loading');

            if (productListXhr) {
                productListXhr.abort();
            }

            var xhr = productListXhr = new XMLHttpRequest();
            xhr.open("GET", url, true);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.onload = function() {
                if (xhr.status >= 200 && xhr.status < 400) {
                    var data = JSON.parse(xhr.responseText);
                    productListItemsContainer.innerHTML += data.items;

                    if (data.next) {
                        element.setAttribute('data-url', data.next);
                        element.parentNode.style.visibility = 'visible';
                    } else {
                        element.parentNode.style.visibility = 'hidden';
                    }

                    element.classList.remove('loading');
                }
            };
            xhr.send();

            return false;
        }
    });

    // Close and open sidebar
    document.body.addEventListener('click', function (event) {
        if (event.target.closest('.pls-toggle')) {
            if (document.body.classList.contains('product-list-sidebar-open')) {
                document.body.style.paddingRight = 0;
                document.body.classList.remove('product-list-sidebar-open');
            } else {
                document.body.style.paddingRight = getScrollbarWidth()+'px';
                document.body.classList.add('product-list-sidebar-open');
            }
            return false;
        }
    });


    function sidebar_filters_update(skip_url = false) {
        var productListMainContainer = document.querySelector('.product-list-container');

        if (!productListMainContainer) {
            return false;
        }

        var sidebarContainer = document.querySelector('form.product-list-sidebar');

        if (!sidebarContainer) {
            return false;
        }

        var activeFiltersContainers = document.querySelectorAll('.product-list-sidebar-filters-active');
        var productListItemsContainer = productListMainContainer.querySelector('.product-list-items');
        var productListItemsContentContainer = productListMainContainer.querySelector('.product-list-content');
        var productListItemsHeading = productListMainContainer.querySelector('.product-list-heading');
        var productListFooterButton = sidebarContainer.querySelector('.pls-footer-button');
        var productListItemsLoadMore = productListItemsContentContainer.querySelector('.product-list-items-load-more');
        var productListItemsLoadMoreButton = productListItemsLoadMore.querySelector('.btn');

        activeFiltersContainers.forEach(function(container){
            container.innerHTML = '';
        })

        var selection = {};
        document.querySelectorAll('.product-list-sidebar input[name="q"], .pls-filters-toggle.selected').forEach(function(btn) {
            var key = btn.getAttribute('data-filters-key');
            var value = btn.getAttribute('data-filters-value');
            var text = btn.innerText;

            if (btn.tagName === 'INPUT') {
                key = btn.getAttribute('name');
                value = '';
                text = '«'+btn.value+'»';
            }

            if (!selection.hasOwnProperty(key)) {
                selection[key] = [];
            }
            selection[key].push(value);

            activeFiltersContainers.forEach(function(container){
                var node = document.createElement("button");
                node.classList.add('btn');
                if (btn.tagName === 'INPUT') {
                    node.classList.add('btn-danger');
                } else {
                    node.classList.add('btn-primary');
                }
                node.classList.add('pls-filters-deselect');
                node.setAttribute('type', 'button');
                node.setAttribute('data-filters-key', key);
                node.setAttribute('data-filters-value', value);
                node.setAttribute('title', container.getAttribute('data-btn-title'));
                node.innerText = text;

                container.prepend(node);
            });
        });

        if (Object.keys(selection).length) {
            sidebarContainer.classList.add('has-selected-filters');
        } else {
            sidebarContainer.classList.remove('has-selected-filters');
        }

        // Add hidden input fields from sidebar form
        document.querySelectorAll('.product-list-sidebar input[type="hidden"]').forEach(function(input){
            var key = input.name;
            var value = input.value;
            if (!selection.hasOwnProperty(key)) {
                selection[key] = [];
            }
            selection[key].push(value);
        });

        if (!skip_url) {
            // Serialize URL
            var url = [];
            for (var p in selection)
                if (selection.hasOwnProperty(p)) {
                    url.push(encodeURIComponent(p) + "=" + encodeURIComponent(selection[p].join('.')));
                }
            url = '?'+url.join('&');

            history.replaceState({}, '', url);

            productListItemsContentContainer.classList.add('loading');

            var canonicalUrl = productListMainContainer.getAttribute('data-source-url');

            if (productListXhr) {
                productListXhr.abort();
            }

            var xhr = productListXhr = new XMLHttpRequest();
            xhr.open("GET", canonicalUrl+url, true);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.onload = function() {
                if (xhr.status >= 200 && xhr.status < 400) {
                    var data = JSON.parse(xhr.responseText);
                    productListItemsContainer.innerHTML = data.items;
                    productListItemsHeading.querySelector('.text').innerHTML = data.heading;
                    productListItemsHeading.querySelector('.count').innerHTML = data.count;

                    if (data.count > 0) {
                        productListItemsContentContainer.classList.remove('empty');
                    } else {
                        productListItemsContentContainer.classList.add('empty');
                    }

                    
                    var textTemplateOne =  productListFooterButton.getAttribute('data-text-template-one');
                    var textTemplateMany =  productListFooterButton.getAttribute('data-text-template-many');
                    var textTemplateEmpty =  productListFooterButton.getAttribute('data-text-template-empty');

                    if (data.count > 0) {
                        var text = (data.count % 10 === 1) ? textTemplateOne : textTemplateMany;
                        text = text.replace('%s', data.count);
                        productListFooterButton.disabled = false;
                        productListFooterButton.innerText = text;
                    } else {
                        productListFooterButton.disabled = true;
                        productListFooterButton.innerText = textTemplateEmpty;
                    }

                    if (data.next) {
                        productListItemsLoadMoreButton.setAttribute('data-url', data.next);
                        productListItemsLoadMore.style.visibility = 'visible';
                    } else {
                        productListItemsLoadMore.style.visibility = 'hidden';
                    }

                    productListItemsContentContainer.classList.remove('loading');
                }
            };
            xhr.send();
        }
    }
})();